import type { ExtensionApi } from './extension';

export class View {
  preprocessing(api: ExtensionApi, ...args: any[]) {
    console.warn('`preprocessing` method is not implemented.');
  }

  render(api: ExtensionApi, ...args: any[]) {
    throw new Error('`render` method is not implemented.');
  }

  destroy() {
    throw new Error('`destroy` method is not implemented.');
  }
}
